// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import {Balance} from '../../comp/balance';
import {Text} from '../../comp/text';
import {Withdraw_section} from '../redeem/withdraw_section.js';
import {Ads} from './ads.js';
import * as cns from './cashout.module.less';

export function Cashout(){
    return <div>
      <div className={cns.row}>
        <div className={cns.header}>
          <Text.xxxl h2>Cashout</Text.xxxl>
          <Text.xl className={cns.brief} secondary>
            Redeem your earnings using PayPal, Wise, or Amazon gift cards
            for maximum convenience!
          </Text.xl>
        </div>
        <Balance className={cns.balance} big caption="Your balance"/>
      </div>
      <Withdraw_section className={cns.withdraw}/>
      <Ads className={cns.ads}/>
    </div>;
}
